function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlagLevel03 = function SvgFlagLevel03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.5 0 10 4.5 10 10s-4.5 10-10 10S0 15.5 0 10 4.5 0 10 0z",
    style: {
      fill: "#f25730"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.8c0-.3-.3-.6-.6-.6s-.6.3-.6.6v8.4c0 .3.3.6.6.6s.6-.3.6-.6v-3c.4.3.9.6 1.6.6.6 0 1.1-.3 1.7-.6.6-.3 1.1-.6 1.7-.6 1.4 0 2.2 1.2 2.2 1.2V7s-.8-1.2-2.2-1.2c-.6 0-1.1.3-1.7.6-.6.3-1.1.6-1.7.6-.7 0-1.2-.3-1.6-.6v-.6z",
    style: {
      fill: "#061b09"
    }
  }));
};
export default SvgFlagLevel03;